import { Link } from "react-router-dom";

export default function Widget({name,image,items,link,status}:any) {
    return (
        <div className="col ps-0">
            <div className="card shadow rounded border-0">
                <div className="row g-0">
                    <div className="col-1">
                        <img src={image} className="img-fluid rounded-start h-100" alt="widget-banner"/>
                    </div>
                    <div className="col-11">
                        <div className="card-body" style={{minHeight:"125px"}}>
                        {!status && <span className="badge bg-secondary float-end">غیر فعال</span>}
                            <h5 className="card-title">
                                {name}
                            </h5>
                            
                            <ul className="card-text mb-2">
                                {items && items.map((value:any,index:number) => 
                                    <li key={index}>{value}</li>
                                )}
                            </ul>
                        </div>
                        <div className="card-footer text-end m-0">
                            {link && status ?
                                <Link to={link.url} className="btn btn-outline-secondary">{link.name}</Link>
                            : link.url === '/edit-pages' ?
                                <Link to="/" className="btn btn-outline-primary">در حال ایجاد...</Link> 
                                :
                                <Link to="/package" className="btn btn-outline-primary">فعال سازی</Link> 
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>   
    )
}